import React from 'react';
import classNames from 'classnames';
import iCThetanCoin from 'assets/img/thetan_coin_V2.png';
import icThetanGem from 'assets/img/thetan_gem_V2.png';
import icPowerPoint from 'assets/img/power_point_V2.png';
import styles from './styles.module.scss';
import { formatCurrency, formatCurrencyInFiat } from '@wolffun/system-currency';
import { InGameCurrency } from '../../config';
import BN from 'bn.js';
import { useTypedSelector } from '@profile/src/redux/utils';
import { getUserCap } from '../ClaimTokenModal/utils';
import { getRemainTime } from '@profile/src/utils/date';
import ResponsiveButton from '@profile/src/Components/ResponsiveButton';
import { getFeatureToggle } from '@wolffun/analytics';
const coinTypeMap = {
  [InGameCurrency.INGAME_THETAN_COIN]: {
    name: 'Thetan Coin',
    image: iCThetanCoin,
    currency: 'THC'
  },
  [InGameCurrency.INGAME_THETAN_GEM]: {
    name: 'Thetan Gem',
    image: icThetanGem,
    currency: 'THG'
  },
  [InGameCurrency.INGAME_POWER_POINT]: {
    name: 'Power Point',
    image: icPowerPoint,
    currency: 'PP'
  }
};

const IngameCoinCard = ({
  className,
  coinType,
  claimable,
  onClickClaim,
  amount,
  disabled
}) => {
  const coinInfo = coinTypeMap[coinType];
  const amountBN = new BN(amount ? amount.value : 0);
  const ingameBalance = useTypedSelector(state => state.ingameBalance.data); // const config = useTypedSelector(
  //   state => state.entities.currencyConfig?.config
  // );
  // const userCap = useTypedSelector(
  //   state => state.entities.currencyConfig?.userCap
  // );

  const config = useTypedSelector(state => state.ingameBalance.data.config);
  const userCap = useTypedSelector(state => state.ingameBalance.data.userCap);
  const [countDown, setCountDown] = React.useState('');
  const [allowClaimable, setAllowClaimable] = React.useState(false);
  const [isDisabledWalletDeposit, setIsDisabledWalletDeposit] = React.useState(false);
  React.useEffect(() => {
    const fetchToggleFeature = async () => {
      const isDisabled = await getFeatureToggle('market_disable_wallet_deposit');
      setIsDisabledWalletDeposit(isDisabled === 'true');
    };

    fetchToggleFeature();
  }, []);
  React.useEffect(() => {
    const {
      remainClaimTime
    } = getUserCap({
      config,
      userCap
    }, coinType);
    const remainTime = getRemainTime(remainClaimTime);

    if (remainClaimTime === 0) {
      setAllowClaimable(true);
    } else {
      setAllowClaimable(false);
    }

    setCountDown(remainTime);
    const timeout = setInterval(() => {
      const {
        remainClaimTime
      } = getUserCap({
        config,
        userCap
      }, coinType);
      const remainTime = getRemainTime(remainClaimTime);

      if (remainClaimTime === 0) {
        setAllowClaimable(true);
      } else {
        setAllowClaimable(false);
      }

      setCountDown(remainTime);
    }, 1000);
    return () => clearInterval(timeout);
  }, [ingameBalance, coinType]);

  const renderMessage = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.message, styles.notAllow)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.spanMessage
    }, !allowClaimable && ` *Next claim available in : ${countDown}`));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.icon, coinType === InGameCurrency.INGAME_THETAN_COIN ? styles.yellow : null, coinType === InGameCurrency.INGAME_THETAN_GEM ? styles.green : null)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    src: coinInfo.image
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, coinInfo.name)), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.coin, coinType === InGameCurrency.INGAME_THETAN_COIN ? styles.yellow : null, coinType === InGameCurrency.INGAME_THETAN_GEM ? styles.green : null)
  }, amount && formatCurrency(amount, {
    withCurrency: true,
    trimWholeFraction: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.subCoin
  }, amount && formatCurrencyInFiat(amount, {
    withCurrency: true,
    trimWholeFraction: true
  }))), !isDisabledWalletDeposit && claimable ? renderMessage() : '', coinType === InGameCurrency.INGAME_THETAN_GEM && /*#__PURE__*/React.createElement(ResponsiveButton, {
    onClick: () => {
      if (amount) {
        onClickClaim(coinType, amount);
      }
    },
    disabled: disabled || !claimable || amountBN.isZero() || !allowClaimable,
    className: styles.btn,
    title: !claimable ? 'Not to Claim' : 'Claim'
  })));
};

export default IngameCoinCard;